export default __webpack_public_path__ + "static/placeholder-6a59254a9dbab59f7ef3f94b027c8c66.jpg";